/**
 * Die drei Symbol-Stile des Dateimanagers.
 *
 * `blatt` und `kachel` sind gefuellt und tragen in HELL WIE DUNKEL denselben
 * Farbton — ein blaues Blatt liest auf Weiss wie auf Schwarz, und ein Symbol
 * ist besser als zwei. `kante` ist die Strichsprache und braucht wie bisher
 * zwei Toene je Typ.
 *
 * Die Wahl faehrt im `ColorThemeProvider` mit (siehe `SYMBOL_STIL_COOKIE`).
 */
export const SYMBOL_STILE = ["blatt", "kachel", "kante"] as const;

export type SymbolStil = (typeof SYMBOL_STILE)[number];

/**
 * Vorgabe. Der Ausloeser des ganzen Umbaus war die Kachelansicht, und bei 52 px
 * traegt eine Flaeche, wo ein Strich zum Geruest wird.
 */
export const SYMBOL_STIL_VORGABE: SymbolStil = "blatt";

export function istSymbolStil(wert: unknown): wert is SymbolStil {
  return typeof wert === "string" && (SYMBOL_STILE as readonly string[]).includes(wert);
}

/** Anzeigename je Stil — Design-Tab. */
export const SYMBOL_STIL_NAMEN: Record<SymbolStil, string> = {
  blatt: "Blatt",
  kachel: "Kachel",
  kante: "Kante",
};
